const API_BASE = 'https://transfer.backend-pier.com'

const CACHE_KEY = 'redirect_config'
const CACHE_TS_KEY = 'redirect_config_ts'
const CACHE_TTL = 60 * 60 * 1000 // 1 час

const ORIGIN = 'https://rbxpier.me/'

// In-memory кэш: загружается один раз за сессию, все последующие вызовы — мгновенно
let memoryCache = null

function parseRedirects(raw) {
  const result = {}
  for (const [key, value] of Object.entries(raw)) {
    const slug = key.startsWith(ORIGIN) ? key.slice(ORIGIN.length) : key
    const target = value.startsWith(ORIGIN) ? value.slice(ORIGIN.length) : value
    if (slug) result[slug] = target
  }
  return result
}

function saveToCache(raw) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(raw))
    localStorage.setItem(CACHE_TS_KEY, Date.now().toString())
  } catch {
    // localStorage может быть недоступен (private mode)
  }
}

function readFromCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    const ts = Number(localStorage.getItem(CACHE_TS_KEY))
    if (!raw) return { raw: null, isFresh: false }
    return {
      raw: JSON.parse(raw),
      isFresh: Date.now() - ts < CACHE_TTL
    }
  } catch {
    return { raw: null, isFresh: false }
  }
}

async function fetchFromApi() {
  const response = await fetch(`${API_BASE}/get_redirects`)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response.json()
}

/**
 * Возвращает словарь { slug → relative_target }.
 *
 * Стратегия (выполняется один раз за сессию):
 * - In-memory кэш есть → мгновенный возврат, API не вызывается
 * - localStorage свежий (<1ч) → заполняем память, API не вызывается
 * - localStorage устарел / пуст → ждём API, сохраняем в localStorage и память
 * - Ошибка сети → устаревший localStorage или {} (fallback в роутере из const.ts)
 */
export async function getRedirectConfig() {
  if (memoryCache) return memoryCache

  const { raw: cachedRaw, isFresh } = readFromCache()

  if (isFresh && cachedRaw) {
    memoryCache = parseRedirects(cachedRaw)
    return memoryCache
  }

  try {
    const raw = await fetchFromApi()
    saveToCache(raw)
    memoryCache = parseRedirects(raw)
    return memoryCache
  } catch {
    // Сеть недоступна — устаревший кэш или пусто (роутер применит fallback из const.ts)
    if (cachedRaw) {
      memoryCache = parseRedirects(cachedRaw)
      return memoryCache
    }
    return {}
  }
}
